import React, { useState, useEffect } from 'react';
import { makeRequest } from '../../../utils/makeRequest';
import { getOfflineFAQsURL } from '../../../utils/urls';


const OfflineFAQ = () => {
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(null);

    const getFAQs = async () => {
        try {
            setLoading(true);
            const response = await makeRequest(`${getOfflineFAQsURL}`, "GET");

            console.log("Response:", response);

            if (response.success && Array.isArray(response.data.faqs)) {
                setFaqs(response.data.faqs);
            } else {
                throw new Error(response.error || "Failed to fetch FAQs");
            }
        } catch (err) {
            console.error("Error fetching FAQs:", err);
            // toastify(err.message, "error");
            setFaqs([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getFAQs();
    }, []);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "75vh" }}>
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 mb-0 text-muted">Loading FAQs...</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* Navbar */}
            <nav className="navbar navbar-light bg-light shadow-sm px-3">
                <div className="container d-flex align-items-center justify-content-between">
                    <a className="navbar-brand fw-bold" href="/">Payserve</a>
                    <div>
                        <a className="mx-3 text-decoration-none text-dark fw-bold" href="/">Home</a>
                        <a className="text-decoration-none text-dark fw-bold" href="/faqs">FAQ</a>
                    </div>
                    <div className="invisible navbar-brand"></div>
                </div>
            </nav>

            {/* FAQ Section */}
            <div className="container my-5" style={{ maxWidth: "95%" }}>
                <div className="card shadow-sm border-0">
                    <div className="card-body">
                        <div className="accordion" id="faqAccordion">
                            {faqs.map((faq, index) => (
                                <div key={faq.id} className="accordion-item border-0">
                                    <h3 className="accordion-header mb-0">
                                        <button
                                            className={`accordion-button ${activeIndex === index ? '' : 'collapsed'} fw-semibold`}
                                            type="button"
                                            onClick={() => toggleFAQ(index)}
                                            style={{
                                                backgroundColor: activeIndex === index ? '#f8f9fa' : 'white'
                                            }}
                                        >
                                            <span className="text-primary me-2">Q{index + 1}:</span>
                                            {faq.question}
                                        </button>
                                    </h3>
                                    <div className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}>
                                        <div className="accordion-body bg-light">
                                            <div className="d-flex">
                                                <span className="text-success fw-bold me-2">A:</span>
                                                <div>{faq.answer}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfflineFAQ;
